import WatchlistButtonHeader from './watchlistbutton-header.js';

const pluginName = 'watchlistbutton-header';
const elements   = '[data-watchlist-button-header]';

export default {
    init() {
        $.fn[pluginName] = function() {
            return this.each((i, el) => {
                const watchlistButtonHeader = new WatchlistButtonHeader(el);
                watchlistButtonHeader.init();
            });
        };

        $(elements)[pluginName]();
    }
};
